// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__vL3FY","sectionsWrapper":"style_sectionsWrapper__2__lo"};